import { render, staticRenderFns } from "./PublicityDetail.vue?vue&type=template&id=86193b0a&scoped=true"
import script from "./PublicityDetail.vue?vue&type=script&lang=js"
export * from "./PublicityDetail.vue?vue&type=script&lang=js"
import style0 from "./PublicityDetail.vue?vue&type=style&index=0&id=86193b0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86193b0a",
  null
  
)

export default component.exports